var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKeyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36341_19493",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H16.4999V16.5H1.5V1.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36341_19493)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.748 2.625C3.85125 2.625 2.625 3.92475 2.625 5.937V12.063C2.625 14.0752 3.85125 15.375 5.748 15.375H12.249C14.148 15.375 15.375 14.0752 15.375 12.063V5.937C15.375 3.92475 14.148 2.625 12.2505 2.625H5.748ZM12.249 16.5H5.748C3.207 16.5 1.5 14.7165 1.5 12.063V5.937C1.5 3.2835 3.207 1.5 5.748 1.5H12.2505C14.7922 1.5 16.5 3.2835 16.5 5.937V12.063C16.5 14.7165 14.7922 16.5 12.249 16.5Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62909 8.17187C6.17159 8.17187 5.80109 8.54237 5.80109 8.99837C5.80109 9.45437 6.17159 9.82487 6.62759 9.82487C7.08284 9.82487 7.45409 9.45437 7.45409 8.99837C7.45409 8.54312 7.08359 8.17262 6.62909 8.17187ZM6.62759 10.9499C5.55134 10.9499 4.67609 10.0739 4.67609 8.99837C4.67609 7.92213 5.55134 7.04688 6.62759 7.04688C7.70534 7.04763 8.57909 7.92287 8.57909 8.99837C8.57909 10.0739 7.70384 10.9499 6.62759 10.9499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7573 10.9523C12.4468 10.9523 12.1948 10.7002 12.1948 10.3898V9.5625H8.0188C7.7083 9.5625 7.4563 9.31125 7.4563 9C7.4563 8.6895 7.7083 8.4375 8.0188 8.4375H12.7573C13.0678 8.4375 13.3198 8.6895 13.3198 9V10.3898C13.3198 10.7002 13.0678 10.9523 12.7573 10.9523Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6361 10.9523C10.3256 10.9523 10.0736 10.7002 10.0736 10.3898V9C10.0736 8.6895 10.3256 8.4375 10.6361 8.4375C10.9466 8.4375 11.1986 8.6895 11.1986 9V10.3898C11.1986 10.7002 10.9466 10.9523 10.6361 10.9523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyWhite);
export default __webpack_public_path__ + "static/media/Icon_key_white.8832e93331c40f8de18a7aac575d30db.svg";
export { ForwardRef as ReactComponent };